import clsx from "clsx";

export default function HighlightBar({
  className = "",
}: {
  className?: string;
}) {
  return <div className={clsx(className, "mx-auto h-1 w-32 bg-hc-red")} />;
}
